<template>
  <div>
    <div class="row border-bottom border-secondary mb-1">
      <p class="mb-2 font-weight-medium">Total de NFS-e: {{resumo.total}} | Valor Total de NFS-e: {{resumo.valor_notas | formatNumeroBr}} | Valor Total do ISS: {{resumo.valor_iss | formatNumeroBr}} </p>
    </div>
    <div v-show="!list_notas || list_notas.length < 1" role="alert" aria-live="polite"
         aria-atomic="true" class="alert alert-primary text-center">
      Sem notas
    </div>
    <div v-for="g in list_avulsas" :key="g.reb_codigo" class="row">
      <div class="col-md-12 mb-3 border-bottom border-secondary">
        <div class="row">
          <div class="col-md-4">
            <b-form-group label="Recibo Provisório">
              <h6 class="mb-0 text-body font-weight-bold">
                {{ g.reb_numero }}
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Emissão - Competência">
              <h6 class="mb-0">
                <span class="text-body font-weight-bold">{{ g.reb_emissao | formatDate }} - </span>
                <span class="text-body font-weight-bold">{{ g.sep_competencia | formatDateCompetencia }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Situação">
              <h6 class="mb-0">
                <span class="badge badge-warning font-size-12">Aguardando Pagamento</span>
              </h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div v-if="g.sep_cpf_cnpj_tomador" class="col-md-4">
            <b-form-group label="CPF/CNPJ Tomador">
              <h6 class="mb-0">
                <span v-if="g.sep_cpf_cnpj_tomador.length < 12">{{
                    g.sep_cpf_cnpj_tomador | VMask('###.###.###-##')
                  }}</span>
                <span v-else>{{ g.sep_cpf_cnpj_tomador| VMask('##.###.###/####-##') }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Nome/Razao Social Tomador">
              <h6 class="mb-0">{{ g.sep_razao_social_tomador }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Valor da Nota">
              <h6 class="mb-0">{{ g.sep_valor | formatNumeroBr }}</h6>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>
    <div v-for="g in list_notas" :key="g.tps_codigo" class="row">
      <div class="col-md-12 mb-1 border-bottom border-secondary">
        <div class="row mb-1">
          <div class="col-md-4">
            <b-form-group label="Nota Fiscal">
              <h6 class="mb-0">
                <span class="text-body font-weight-bold" v-if="!g.not_numero">-</span>
                <span class="text-body font-weight-bold" v-else>
                  <router-link tag="a" target="_blank"
                               :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: g.not_hash}}">
                    {{ g.not_numero }}
                  </router-link>
                </span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Emissão - Competência">
              <h6 class="mb-0">
                <span v-if="!g.not_emissao"> - </span>
                <span class="text-body font-weight-bold" v-else>{{ g.not_emissao | formatDateHora }} - </span>
                <span class="text-body font-weight-bold">{{ g.sep_competencia | formatDateCompetencia }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Situação">
              <h6 class="mb-0">
                <span v-show="g.soc_codigo" class="badge badge-danger font-size-12">Cancelada</span>
                <span v-show="g.not_numero && !g.soc_codigo" class="badge badge-success font-size-12">Emitida</span>
                <span v-show="g.not_substituicao" class="ml-1 badge badge-warning font-size-12">Substituída</span>
              </h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <b-form-group label="Código do Prestador">
              <h6 class="mb-0">{{ g.eco_codigo }}</h6>
            </b-form-group>
          </div>
          <div v-if="g.sep_cpf_cnpj_prestador" class="col-md-4">
            <b-form-group label="CPF/CNPJ Prestador">
              <h6 class="mb-0">
                <span v-if="g.sep_cpf_cnpj_prestador.length < 12">{{
                    g.sep_cpf_cnpj_prestador | VMask('###.###.###-##')
                  }}</span>
                <span v-else>{{ g.sep_cpf_cnpj_prestador| VMask('##.###.###/####-##') }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Nome/Razao Social Prestador">
              <h6 class="mb-0">{{ g.sep_razao_social_prestador }}</h6>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div v-if="g.sep_cpf_cnpj_tomador" class="col-md-4">
            <b-form-group label="CPF/CNPJ Tomador">
              <h6 class="mb-0">
                <span v-if="g.sep_cpf_cnpj_tomador.length < 12">{{
                    g.sep_cpf_cnpj_tomador | VMask('###.###.###-##')
                  }}</span>
                <span v-else>{{ g.sep_cpf_cnpj_tomador| VMask('##.###.###/####-##') }}</span>
              </h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Nome/Razao Social Tomador">
              <h6 class="mb-0">{{ g.sep_razao_social_tomador }}</h6>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group label="Valor da Nota">
              <h6 class="mb-0">{{ g.sep_valor | formatNumeroBr }}</h6>
            </b-form-group>
          </div>
        </div>
        <div v-if="g.not_substituicao" class="row">
          <div class="col-md-4">
            <b-form-group label="Nota Substituta">
              <h6 class="mb-0">
                <span class="text-body font-weight-bold">
                  <router-link tag="a" target="_blank"
                               :to="{name: 'contribuinte-nota-fiscal-visualizar', params: {not_hash: g.substituicao}}">
                    {{ g.not_substituicao }}
                  </router-link>
                </span>
              </h6>
            </b-form-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    resumo: {
      type: Object,
      default: () => ({
        total: 0,
        valor_notas: 0,
        valor_iss: 0
      })
    },
    list_notas: {
      type: Array,
      default: () => []
    },
    list_avulsas: {
      type: Array,
      default: () => []
    },
  },
};
</script>

<style>
.dropzone .dz-preview {
  display: inherit;
}

.vue-dropzone > .dz-preview .dz-remove {
  padding: 5px;
  bottom: 5px;
}
</style>
